// Simple keyword-based emotion detection so Sakhi Didi can switch to a softer
// voice when the girl is asking about something scary or sad.
// If found, we pick the 'pooja' speaker (soft & caring) for the reply.

const SAD_KEYWORDS = [
  // English
  "sad", "cry", "crying", "upset", "afraid", "scared", "fear", "hurt", "lonely",
  "alone", "worried", "worry", "anxious", "anxiety", "embarrass", "ashamed",
  "shy", "unsafe", "help me", "no one loves", "want to die", "abuse",
  "touched me", "bad touch", "hate myself",
  // Hindi (Devanagari)
  "उदास", "रोना", "रो रही", "अकेल", "डर", "डरी", "चिंता", "शर्म", "दुख",
  "तकलीफ", "अकेली", "अकेला", "बुरा स्पर्श", "गलत तरीके", "नफरत",
  // Marathi
  "एकट", "भीत", "काळजी", "वेदना", "दुःख", "लज्ज",
  // Telugu
  "దుఃఖ", "ఏకాంత", "భయం", "ఆందోళన", "సిగ్గు", "బాధ", "ఒంటరిగా",
];

export function detectEmotion(text) {
  if (!text) return "neutral";
  const q = text.toLowerCase();
  for (const kw of SAD_KEYWORDS) {
    if (q.includes(kw.toLowerCase())) return "soft";
  }
  return "neutral";
}
